import {
  faBiking,
  faCar,
  faClock,
  faShoppingBag,
  faUtensils
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Button } from 'reactstrap';
import '../../assets/css/login.scss';
import CONSTANTS from '../../constants';

const RADIO_ICONS = {
  [CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY]: faBiking,
  [CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DINE_IN]: faUtensils,
  [CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.PICK_UP]: faShoppingBag,
  [CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.CURBSIDE_PICKUP]: faCar
};
class BinDiscountsCard extends Component {

  constructor() {
    super();
  }

  render() {
    let bindiscount = this.props.bindiscount;
    const blankbin = bindiscount.code.length === 6 ? 'XXXXXXXXXX' : 'XXXXXXXX';
    let card = bindiscount.code + blankbin;
    card = card.substring(0, 4) + ' ' +
      card.substring(4, 8) + ' ' +
      card.substring(8, 12) + ' ' +
      card.substring(12, 16);
    return (
      <div className="col-lg-4 pb-2">
        <div className='card hovernowshodow bin-card box-shadow p-3 card-color' onClick={() => this.props.openTerms(bindiscount)}>
          <div className="row">
            <div className="col-lg-12" >
              <div className='d-flex justify-content-between'>
                <span className='card-subtitle-color' style={{ fontSize: '13px' }}>{card}</span>
                {bindiscount.max_discount_amount ? <span className='card-subtitle-color' style={{ fontSize: '13px' }}>Cap: Rs {bindiscount.max_discount_amount ? bindiscount.max_discount_amount : 0}</span> : ''}
              </div>
              <div className='pt-2 pb-2'>
                {ReactHtmlParser(bindiscount.binText)}
              </div>
              <div className='d-flex justify-content-between'>
                <div className='d-flex'>
                  <div className='d-flex
                 border border-1 p-1 rounded-2'>
                    {bindiscount.BindiscountOrderTypes && bindiscount.BindiscountOrderTypes
                      .map((ot) => {
                        return <div className="icon pe-1 ps-1">
                          <FontAwesomeIcon icon={RADIO_ICONS[ot.OrderType.order_type]} color='var(--card-subtitle-color)' />
                        </div>
                      })}

                  </div>
                  {bindiscount.applicable_time_type === 1 || bindiscount.applicable_time_type === 2 ?
                    <div className='border border-1 p-1 rounded-2 ms-1 me-4'>
                      <div className="icon">
                        <FontAwesomeIcon icon={faClock} color='var(--card-subtitle-color)' />
                      </div>
                    </div>
                    : ''}
                </div>
                <Button className='branding-btn' style={{ cursor: 'pointer', fontSize: '12px' }}>T&C</Button>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default BinDiscountsCard;
